export var ComplianceStatus;
(function (ComplianceStatus) {
    ComplianceStatus["COMPLIANCE_STATUS_COMPLIANT"] = "COMPLIANT";
    ComplianceStatus["COMPLIANCE_STATUS_VIOLATIONS"] = "VIOLATIONS";
    ComplianceStatus["COMPLIANCE_STATUS_ALL_MUTED"] = "ALL_MUTED";
})(ComplianceStatus || (ComplianceStatus = {}));
